export const clubsMenuItems = [
  {
    key: "member_privileges",
    icon: "/assets/images/nav/nav_badge.png",
    path: "/#member_privileges",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "mem_privileges",
  },
  {
    key: "earn_s_dollar",
    icon: "/assets/images/nav/nav_monetization.png",
    path: "/earn",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "earn_dollar",
  },
  {
    key: "burn_s_dollar",
    icon: "/assets/images/nav/nav_monetization.png",
    path: "/redeem",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "redemption",
  },
  /*{
    key: "smart_academy",
    icon: "/assets/images/nav/nav_festival.png",
    path: "/smart_academy?type=smart_academy",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "smart_academy",
  },*/
  {
      key: "galaxy_ai_academy",
      icon: "/assets/images/nav/nav_festival.png",
      path: "/galaxy_ai_academy_landing", 
      event_name: "clubs_menu",
      event_action: "menu_bar",
      event_label: "experience_reg",
  },
  {
    key: "event_experience",
    icon: "/assets/images/nav/nav_festival.png",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "experience",
    subMenu: [
      {
        key: "event_registration",
        labelKey: "header:event_registration",
        path: "/galaxy_ai_academy",
        event_name: "clubs_menu",
        event_action: "menu_subbar",
        event_label: "experience_reg",
      },
      {
        key: "event_inquiry",
        labelKey: "header:event_inquiry",
        path: "/inquiry",
        event_name: "clubs_menu",
        event_action: "menu_subbar",
        event_label: "experience_enquiry",
      },
    ],
  },
  {
    key: "latest_videos",
    icon: "/assets/images/nav/nav_festival.png",
    path: "/videos",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "video",
  },
  {
    key: "latest_blogs",
    icon: "/assets/images/nav/nav_festival.png",
    path: "/blogs",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "blog",
  },
  {
    key: "services",
    icon: "/assets/images/nav/nav_support_agent.png",
    url_hk: "https://www.samsung.com/hk/support/prebooking/",
    url_hk_en: "https://www.samsung.com/hk_en/support/prebooking/",
    event_name: "clubs_menu",
    event_action: "menu_bar",
    event_label: "service",
  },
];
